module.exports = __webpack_public_path__ + "355CC9_0_0.woff?33b08f976e147bd35b9df6e95671d7b7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/355CC9_0_0.woff
// module id = 8
// module chunks = 0